<template>
  <!--  @click="onGalleryContainer" -->
  <VueGallery
    :images="images"
    :index="index"
    @slide="onGalleryThumb"
    @close="onGalleryClose"
  />
</template>

<script>
import VueGallery from 'vue-gallery'
import { mapState } from 'vuex'

export default {
  name: 'Gallery',
  components: {
    VueGallery,
  },
  data() {
    return {
      index: null,
    }
  },
  computed: {
    ...mapState(['galleryModal']),
    ...mapState({
      images: (state) => {
        if (Array.isArray(state.product.imgf) && state.product.imgf.length) {
          return state.product.imgf
            .map((img) => (/,/gm.test(img) || img === '' ? null : `/img${img}`))
            .filter((item) => item)
        } else if (
          Array.isArray(state.product.img) &&
          state.product.img.length &&
          state.product.img[0]
        ) {
          return state.product.img.map((img) =>
            img ? `/img${img}` : '/img/uploads/error.png'
          )
        } else if (state.product.img) {
          return [`/img${state.product.img}`]
        } else {
          return ['/img/uploads/error.png']
        }
      },
    }),
  },
  methods: {
    onGalleryClose() {
      this.index = null
      this.$store.commit('setGalleryModal', null)
    },
    onGalleryContainer(e) {
      if (e.target.className === 'slide') {
        this.index = null
        this.$store.commit('setGalleryModal', null)
      }
    },
    onGalleryThumb(n) {
      this.index = n
      this.$store.commit('setGalleryModal', n)
    },
  },
  watch: {
    galleryModal: function (v) {
      this.index = v
    },
  },
}
</script>

<style>
.blueimp-gallery,
.blueimp-gallery > .slides > .slide > .slide-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -moz-backface-visibility: hidden;
  -webkit-transition: opacity 0.2s linear;
  -moz-transition: opacity 0.2s linear;
  -ms-transition: opacity 0.2s linear;
  -o-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}

.blueimp-gallery > .slides > .slide > .slide-content {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  opacity: 1;
  margin: auto;
}

.blueimp-gallery {
  position: fixed;
  z-index: 999999;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.9);
  opacity: 0;
  display: none;
  direction: ltr;
  -ms-touch-action: none;
  touch-action: none;
}

.blueimp-gallery-carousel {
  position: relative;
  z-index: auto;
  padding-bottom: 56.25%;
  box-shadow: 0 0 10px #000;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  margin: 1em auto;
}

.blueimp-gallery-display {
  display: block;
  opacity: 1;
}

.blueimp-gallery > .slides {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.blueimp-gallery-carousel > .slides {
  position: absolute;
}

.blueimp-gallery > .slides > .slide {
  position: relative;
  float: left;
  height: 100%;
  text-align: center;
  -webkit-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  -moz-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  -ms-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  -o-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
}

.blueimp-gallery > .slides > .slide-loading > .slide-content {
  opacity: 0;
}

.blueimp-gallery > .slides > .slide-error {
  background: url(/img/error.png) center no-repeat;
}

.blueimp-gallery > .next,
.blueimp-gallery > .prev {
  position: absolute;
  top: 50%;
  left: 15px;
  width: 40px;
  height: 40px;
  margin-top: -23px;
  /* font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; */
  font-family: 'Nunito', sans-serif;
  font-size: 60px;
  font-weight: 100;
  line-height: 30px;
  color: #fff;
  text-decoration: none;
  text-shadow: 0 0 2px #000;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  border: 3px solid #fff;
  -webkit-border-radius: 23px;
  -moz-border-radius: 23px;
  border-radius: 23px;
  opacity: 0.5;
  cursor: pointer;
  display: none;
}

.blueimp-gallery > .next {
  left: auto;
  right: 15px;
}

.blueimp-gallery > .close,
.blueimp-gallery > .title {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 20px;
  line-height: 30px;
  color: #fff;
  text-shadow: 0 0 2px #000;
  opacity: 0.8;
  display: none;
  margin: 0 40px 0 0;
}

.blueimp-gallery > .close {
  right: 15px;
  left: auto;
  font-size: 30px;
  text-decoration: none;
  cursor: pointer;
  margin: -15px;
  padding: 15px;
}

.blueimp-gallery > .play-pause {
  position: absolute;
  right: 15px;
  bottom: 15px;
  width: 15px;
  height: 15px;
  background: url(/img/play-pause.png) 0 0 no-repeat;
  cursor: pointer;
  opacity: 0.5;
  display: none;
}

.blueimp-gallery-playing > .play-pause {
  background-position: -15px 0;
}

.blueimp-gallery > .close:hover,
.blueimp-gallery > .next:hover,
.blueimp-gallery > .play-pause:hover,
.blueimp-gallery > .prev:hover,
.blueimp-gallery > .title:hover {
  color: #fff;
  opacity: 1;
}

.blueimp-gallery > .close,
.blueimp-gallery > .next,
.blueimp-gallery > .play-pause,
.blueimp-gallery > .prev,
.blueimp-gallery > .slides > .slide > .slide-content {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

body:last-child .blueimp-gallery > .slides > .slide-error {
  background-image: url(/img/error.svg);
}

body:last-child .blueimp-gallery > .play-pause {
  width: 20px;
  height: 20px;
  background-size: 40px 20px;
  background-image: url(/img/play-pause.svg);
}

body:last-child .blueimp-gallery-playing > .play-pause {
  background-position: -20px 0;
}

* + html .blueimp-gallery > .slides > .slide {
  min-height: 300px;
}

* + html .blueimp-gallery > .slides > .slide > .slide-content {
  position: relative;
}

.blueimp-gallery > .indicator {
  position: absolute;
  top: auto;
  right: 15px;
  bottom: 15px;
  left: 15px;
  list-style: none;
  text-align: center;
  line-height: 10px;
  display: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0 40px;
  padding: 0;
}

.blueimp-gallery > .indicator > li {
  display: inline-block;
  width: 9px;
  height: 9px;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.25) center no-repeat;
  border-radius: 5px;
  box-shadow: 0 0 2px #000;
  opacity: 0.5;
  cursor: pointer;
  margin: 6px 3px 0;
}

.blueimp-gallery > .indicator > .active,
.blueimp-gallery > .indicator > li:hover {
  background-color: #fff;
  opacity: 1;
  border-color: #fff;
}

* + html .blueimp-gallery > .indicator > li {
  display: inline;
}

.blueimp-gallery > .slides > .slide > .video-content > img {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  -moz-backface-visibility: hidden;
  margin: auto;
}

.blueimp-gallery > .slides > .slide > .video-content > video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
}

.blueimp-gallery > .slides > .slide > .video-content > iframe {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.blueimp-gallery > .slides > .slide > .video-playing > iframe {
  top: 0;
}

.blueimp-gallery > .slides > .slide > .video-content > a {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  width: 128px;
  height: 128px;
  background: url(/img/video-play.png) center no-repeat;
  opacity: 0.8;
  cursor: pointer;
  margin: -64px auto 0;
}

.blueimp-gallery > .slides > .slide > .video-content > a:hover {
  opacity: 1;
}

.blueimp-gallery > .slides > .slide > .video-playing > video {
  display: block;
}

body:last-child
  .blueimp-gallery
  > .slides
  > .slide
  > .video-content:not(.video-loading)
  > a {
  background-image: url(/img/video-play.svg);
}

* + html .blueimp-gallery > .slides > .slide > .video-content {
  height: 100%;
}

* + html .blueimp-gallery > .slides > .slide > .video-content > a {
  left: 50%;
  margin-left: -64px;
}

.blueimp-gallery > .slides > .slide-loading,
.blueimp-gallery > .slides > .slide > .video-loading > a {
  background: url(/img/loading.gif) center no-repeat;
  background-size: 64px 64px;
}

.blueimp-gallery > .slides > .slide-error > .slide-content,
.blueimp-gallery-left > .prev,
.blueimp-gallery-right > .next,
.blueimp-gallery-single > .next,
.blueimp-gallery-single > .play-pause,
.blueimp-gallery-single > .prev,
.blueimp-gallery-single > .indicator,
.blueimp-gallery > .slides > .slide > .video-playing > a,
.blueimp-gallery > .slides > .slide > .video-playing > img {
  display: none;
}

.blueimp-gallery-controls > .close,
.blueimp-gallery-controls > .next,
.blueimp-gallery-controls > .play-pause,
.blueimp-gallery-controls > .prev,
.blueimp-gallery-controls > .title,
.blueimp-gallery-controls > .indicator {
  display: block;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}
</style>
